import { EC_LINE009 } from '@/constants'

export default {
  namespaced: true,
  state: () => ({
    subscription: null,
    confirmSubscription: null,
    index: 1,
    subListType: EC_LINE009.TABS_TYPE.NORMAL,
    subscriptionNo: null,
  }),
  getters: {
    getSubscription(state) {
      return state.subscription || {}
    },
    getConfirmSubscription(state) {
      return state.confirmSubscription
    },
    getSubListType(state) {
      return state.subListType
    },
    getSubscriptionNo(state) {
      return state.subscriptionNo
    },
  },
  mutations: {
    UPDATE_SUBSCRIPTION(state, val = null) {
      state.subscription = val
    },
    UPDATE_INDEX(state, val) {
      state.index = val
    },
    UPDATE_SKU_QUANTITY(state, { product_sku_id, quantity }) {
      if (state.subscription && state.subscription.subscription_order_item.length) {
        const idx = state.subscription.subscription_order_item.findIndex((i) => i.product_sku_id === product_sku_id)

        if (idx !== -1) {
          state.subscription.subscription_order_item[idx].quantity = quantity
        }
      }
    },
    ADD_SKU_ITEM(state, { product_sku_id, ...args }) {
      if (state.subscription && state.subscription.subscription_order_item) {
        const idx = state.subscription.subscription_order_item.findIndex((i) => i.product_sku_id === product_sku_id)

        if (idx !== -1) {
          state.subscription.subscription_order_item[idx].quantity += 1
        } else {
          state.subscription.subscription_order_item.push({ product_sku_id, ...args })
        }
      }
    },
    REMOVE_SKU_ITEM(state, product_sku_id) {
      if (state.subscription && state.subscription.subscription_order_item.length) {
        const idx = state.subscription.subscription_order_item.findIndex((i) => i.product_sku_id === product_sku_id)

        if (idx !== -1) {
          state.subscription.subscription_order_item.splice(idx, 1)
        }
      }
    },
    SET_SUBSCRIPTION_CONFIRM(state, payload = null) {
      state.confirmSubscription = payload
    },
    SET_SUB_LIST_TYPE(state, subListType) {
      state.subListType = subListType
    },
    SET_SUBSCRIPTION_NO(state, subscriptionNo) {
      state.subscriptionNo = subscriptionNo
    },
  },
}
